module.exports = __webpack_public_path__ + "img/main_menu_media.2c62e46a.svg";